export const _defaultMaxPenPressureValue = 852;
//# sourceMappingURL=PenConstants.js.map